import React, {Component} from 'react'
import {Button, Collapse, Input} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Query, Mutation} from 'react-apollo'
import PropTypes from 'prop-types'

import ClientSearchList from "./ClientSearchList";
import query from '../../queries/server/search_clients'

export default class ProjectClientInput extends Component {

    state = {
        collapse: false,
        query: ''
    }

    toggle = () => {
        this.setState(state => ({collapse: !state.collapse}));
    }

    addClient = () => {
        this.setState({collapse: false, query: ''})
    }

    render() {

        const {state, props: {project_id}} = this
        return (
            <div>
                <Button
                    size="sm"
                    color={state.collapse ? 'warning' : 'success'}
                    onClick={this.toggle}
                >
                    <FontAwesomeIcon color="#fff"
                                     icon={state.collapse ? 'minus' : 'plus'}/>{' '}{state.collapse ? 'Cancel' : 'Add Client'}
                </Button>

                <Collapse isOpen={state.collapse}>
                    <div className="d-flex flex-column pt-3 mt-3 card card-body bg-light">
                        <Input
                            className="form-control-sm" placeholder="Search Clients..."
                            onChange={(evt) => this.setState({query: evt.target.value})}
                            value={state.query}
                        />
                        <Query query={query} variables={{query: state.query}} skip={!state.query}>
                            {({loading, error, data}) => {

                                if(loading) return <p>Loading...</p>

                                if(data) return <ClientSearchList project_id={project_id} clients={data.search_clients} onClientAdd={this.addClient}/>

                                return null
                            }}

                        </Query>
                    </div>
                </Collapse>

            </div>
        )
    }

}

ProjectClientInput.propTypes = {
    project_id: PropTypes.string.isRequired,
}